import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroAbout() {
  const whatsappLink = 'https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201.';
  return <section className="relative pt-32 pb-12 md:pt-40 md:pb-20 bg-ivory overflow-hidden min-h-[70vh] md:min-h-[85vh] flex items-center" data-id="element-464">
      {/* Decorative botanical background hint */}
      <div className="absolute right-0 top-0 w-1/2 h-full opacity-20 pointer-events-none mix-blend-multiply" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1550047815-671239857d42?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80")',
      backgroundSize: 'cover',
      backgroundPosition: 'left center',
      maskImage: 'linear-gradient(to right, transparent, black)',
      WebkitMaskImage: 'linear-gradient(to right, transparent, black)'
    }} data-id="element-465"></div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 w-full relative z-10" data-id="element-466">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-467">
          {/* Content - Centered text */}
          <div className="lg:col-span-7 order-2 lg:order-1 flex flex-col items-center text-center" data-id="element-468">
            <FadeIn delay={0.1} data-id="element-469">
              <div className="inline-block px-5 py-2 rounded-full border border-forest/30 mb-8" data-id="element-470">
                <span className="font-display text-xs font-semibold tracking-widest uppercase text-forest" data-id="element-471">
                  NLP & CONSTELAȚII FAMILIALE
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-472">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium tracking-wide text-forest mb-4 leading-tight" data-id="element-473">
                Mihaela Iovu
              </h1>
              <p className="font-display text-sm font-semibold tracking-[0.2em] text-forest/70 uppercase mb-8 leading-relaxed max-w-[500px]" data-id="element-474">
                Master Trainer NLP · Facilitator Constelații Familiale · Coach &
                Formator Certificat
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-475">
              <p className="text-[19px] md:text-xl text-charcoal/80 leading-relaxed font-sans max-w-[600px] mb-10" data-id="element-476">
                Nu sunt aici să îți dau răspunsuri rapide sau soluții de
                suprafață. Sunt aici să te ghidez într-un proces real, în care
                să vezi clar unde ești, să eliberezi ce te ține blocată și să te
                reconectezi cu cine ești cu adevărat. Nu lucrez doar cu mintea.
                Lucrez cu tot ce stă în spatele blocajului.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-477">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-forest text-ivory font-display font-medium text-[17px] hover:bg-forest-dark transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-478">
                Programează Sesiunea Cadou
                <ArrowRight className="w-5 h-5" data-id="element-479" />
              </a>
            </FadeIn>
          </div>

          {/* Image - Right side on desktop */}
          <div className="lg:col-span-5 order-1 lg:order-2 relative" data-id="element-480">
            <FadeIn delay={0.3} direction="left" data-id="element-481">
              <div className="relative max-w-[360px] md:max-w-md lg:max-w-[420px] mx-auto" data-id="element-482">
                <div className="relative rounded-[32px] overflow-hidden aspect-[3/4] shadow-2xl border-4 border-ivory" data-id="element-483">
                  <img src="https://cdn.magicpatterns.com/uploads/bbhRnscRmaZkzuZMMer6an/Foto_1.jpg" alt="Mihaela Iovu - Master Trainer NLP și Coach" className="w-full h-full object-cover object-top" data-id="element-484" />
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}